import React from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ComplaintsByDate from './byDateWidget/complaints';
import AnalyticsWidgetByDate from './byDateWidget/analytics';
import { convertDateFormat } from '../../../../widget/util';

function HomeByCalendarPageWidget(props) {
const { id } = useParams();
const convertedDate = convertDateFormat(id);

  return (
    <div>
        <p>{id}</p>
        <div className='row'>
            <div className='col s12'>
                <AnalyticsWidgetByDate datePicked={convertedDate}/>
            </div>
        </div>
        <div className='row'>
          <div className='col s12 '>
            <ComplaintsByDate datePicked={convertedDate}/>
          </div>
        </div>
    </div>
  )
}

export default HomeByCalendarPageWidget